import React from "react";

export const investors = [
    { 
        name: 'Investor1', 
        logo: '/investors/eos-ventures-bw.png',
        alt: 'EOS Ventures'
    },
    { 
        name: 'Investor2', 
        logo: '/investors/hyde-park-bw.png',
        alt: 'Hyde Park Venture Partneers'
    },
    { 
        name: 'Investor3', 
        logo: '/investors/lemhi-ventures-bw.png',
        alt: 'Lemhi Ventures' 
    },
    { 
        name: 'Investor4', 
        logo: '/investors/six-thirty-bw.png',
        alt: 'Six Thirty'
    },
    { 
        name: 'Investor5', 
        logo: '/investors/spring-tide-bw.png',
        alt: 'Spring Tide'
    },
];